module.exports = __webpack_public_path__ + "img/sixpackcarrier29.14dc97c1.jpg";